import t from "./index922.js";
import o from "./index952.js";
import r from "./index835.js";
function f(e) {
  return t(e, r, o);
}
export {
  f as default
};
